<template>
  <div>
    <div style="margin-bottom: 16px;">
      <el-checkbox v-model="checked" label="同时”通过“动态" size="large" />
    </div>
    <div class="dialog-footer" style="text-align: left">
      <el-button @click.native="cancel" >返回</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {updateQualityZoneState, updateZoneState} from '../../../api/url'
import {postFormData, getFormData} from "@/api/api";

export default {
  name: "SetQualityDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      loading: false,
      checked: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['idArr'] = this.idArray;
      param['qualityState'] = 1;
      postFormData(updateQualityZoneState, param).then((data)=>{
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          if(this.checked) {
            this.updateState()
          }
          this.$emit('confirm')
        }else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },

    updateState() {
      let param = {}
      param['idArr'] = this.idArray;
      param['state'] = 1;
      postFormData(updateZoneState, param).then((data)=>{
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
        }else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }


  },
  created() {
  }
}
</script>

<style scoped>

</style>
